export default function isTextEditingElement(el: EventTarget | null): boolean {
  if (!(el instanceof HTMLElement)) {
    return false;
  }

  // <textarea> always has its own undo stack
  if (el.tagName === "TEXTAREA") {
    return true;
  }

  // Text‑type <input>s (exclude buttons, checkboxes, etc.)
  if (el.tagName === "INPUT") {
    const t = (el as HTMLInputElement).type;
    return (
      t === "text" ||
      t === "search" ||
      t === "url" ||
      t === "tel" ||
      t === "email" ||
      t === "password" ||
      t === "number"
    );
  }

  // Any contentEditable region
  if (el.isContentEditable) {
    return true;
  }

  return false;
}
